import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/reference-rate/:referenceRateId/reference-rate-value/:valueId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    referenceRateId: string;
    valueId: string;
}
const mutationFn = ({ referenceRateId, valueId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { referenceRateId, valueId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteReferenceRateValue };
